import { jsx as m } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { ErrorMessageDisplay as u } from "../ErrorMessageDisplay/ErrorMessageDisplay.js";
import { getErrorMessage as i } from "../../utils/getErrorMessage.js";
const l = ({
  error: r,
  errorMessage: t,
  onContactSupport: e
}) => {
  const {
    title: o,
    message: a,
    refreshComponent: s,
    translationValues: n,
    onContactSupport: p
  } = i(r, t, e);
  return /* @__PURE__ */ m(
    u,
    {
      title: o,
      message: a,
      translationValues: n,
      withImage: !0,
      centered: !0,
      refreshComponent: s,
      onContactSupport: p
    }
  );
};
export {
  l as default
};
